import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const Head = ({ ...props }) => {
  return (
    <Helmet>
      <title>{props.title ? props.title + " | " : null} TS Signage</title>
    </Helmet>
  );
};
export default Head;
